// src/data/claimCompletion.js
//
// SECTION 537 (Bob, 2026-09-30, on claim 0013's form: "Employee No.: Submission Date: ... Time of Violation: ... Why
// aren't these filled in?"). They were blank because nobody entered them - Quick File never asked the officer filing
// for Mr. Coyle, and the claim page only LISTED what was missing. Now the officer who may work the claim fills them in
// on the claim page. Pure: which fields, what each must look like, and the patch. The Firestore rules decide who may
// write (lcEdit / gcEdit / adminEdit); the page shows a refusal as it comes.
const s = (v) => (v == null ? '' : String(v)).trim();

export const COMPLETION_FIELDS = [
  { key: 'employeeNumber', label: 'Claimant’s employee number', type: 'text', missing: /employee number/ },
  { key: 'seniorityDate', label: 'Claimant’s seniority date', type: 'date', missing: /seniority date/ },
  { key: 'incidentTime24', label: 'Time of violation', type: 'time', missing: /time of violation/ },
  { key: 'hoursPerDate', label: 'Hours claimed for each date', type: 'number', missing: /hours claimed/ },
  { key: 'amountClaimed', label: 'Total amount claimed ($)', type: 'number', missing: /total amount claimed/ },
  { key: 'presentedTo', label: 'Presented to (name and title)', type: 'text', missing: /presented to/ },
];

// The value the form prints today for a field. Record 635: seniority is the claimant's own seniorityDate, as penaltyClaim.js
// now prints it; subjectSeniorityDate is the other employee's and is never read or written here.
export function currentValue(claim, key) {
  const c = claim || {};
  if (key === 'seniorityDate') return s(c.seniorityDate);
  if (key === 'incidentTime24') return s(c.incidentTime24 || c.incidentTime);
  return s(c[key]);
}

// Every field, its current value, and whether the form lists it as missing.
export function completionRows(claim, missing) {
  const miss = (Array.isArray(missing) ? missing : []).join(' | ');
  return COMPLETION_FIELDS.map(f => ({ ...f, value: currentValue(claim, f.key), isMissing: f.missing.test(miss) }));
}

export function validateValue(key, raw) {
  const v = s(raw);
  if (!v) return { ok: true, value: null };
  const f = COMPLETION_FIELDS.find(x => x.key === key);
  if (!f) return { ok: false, error: 'Unknown field.' };
  if (f.type === 'date' && !/^\d{4}-\d{2}-\d{2}$/.test(v)) return { ok: false, error: f.label + ': use the date picker.' };
  if (f.type === 'time' && !/^([01]\d|2[0-3]):[0-5]\d$/.test(v)) return { ok: false, error: f.label + ': HH:MM, 24-hour.' };
  if (f.type === 'number') {
    const n = parseFloat(v.replace(/[$,\s]/g, ''));
    if (!isFinite(n) || n <= 0) return { ok: false, error: f.label + ': a number above zero.' };
    if (key === 'hoursPerDate' && n > 24) return { ok: false, error: f.label + ': no more than 24.' };
    return { ok: true, value: Math.round(n * 100) / 100 };
  }
  if (v.length > 160) return { ok: false, error: f.label + ': too long.' };
  return { ok: true, value: v };
}

// Only what changed, validated. Seniority is written where the form reads it; the time to both spellings in use.
export function completionPatch(claim, values) {
  const errors = []; const patch = {};
  for (const f of COMPLETION_FIELDS) {
    if (!values || !(f.key in values)) continue;
    const r = validateValue(f.key, values[f.key]);
    if (!r.ok) { errors.push(r.error); continue; }
    const now = currentValue(claim, f.key);
    if (String(r.value == null ? '' : r.value) === now) continue;
    if (f.key === 'seniorityDate') {
      patch.seniorityDate = r.value;
      // Record 635: never subjectSeniorityDate - that is the other employee's date, not the claimant's.
    } else if (f.key === 'incidentTime24') {
      patch.incidentTime24 = r.value;
      if (s((claim || {}).incidentTime)) patch.incidentTime = r.value;
    } else patch[f.key] = r.value;
  }
  return { ok: errors.length === 0, errors, patch, changed: Object.keys(patch).length > 0 };
}
